import { Pipe, PipeTransform } from "@angular/core";
import { TimeSpan } from "../helpers/time-span";

@Pipe({
    name: "timeSpanToString",
    standalone: false
})
export class TimeSpanToStringPipe implements PipeTransform {
  transform(timeString: TimeSpan): string {
    return timeString ? timeString.toStringShort() : "";
  }
}
